module.exports = __webpack_public_path__ + "img/@work_img_back210830.38c8900b.jpg";